"use client";

import { cn } from "@/lib/utils";

/** Shared filter/tab pill button. variant="all" uses a softer active style so "All" blends with the list. */
export function FilterChip({
  active,
  onClick,
  children,
  className,
  variant = "default",
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
  /** "all" = softer active style (border + tint) so "All" doesn't dominate as its own section */
  variant?: "default" | "all";
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={active}
      onClick={onClick}
      className={cn(
        "flex h-10 min-h-11 items-center justify-center rounded-lg px-4 py-2.5 text-center text-sm font-medium shadow-none transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:min-h-0 sm:justify-start",
        variant === "all"
          ? active
            ? "border border-primary bg-primary/10 text-foreground"
            : "border border-transparent bg-muted text-muted-foreground hover:bg-muted/80"
          : active
            ? "border-0 bg-primary text-primary-foreground"
            : "border-0 bg-muted text-muted-foreground hover:bg-muted/80",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
